import { Box, Skeleton } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import { useState } from 'react';

import 'swiper/css';
import 'swiper/css/navigation';

import { sxStyle } from './styles';

const SliderBlock = ({ items, autoplay = true, showArrows = true }) => {
  const multiple = items.length > 1;
  const [loaded, setLoaded] = useState(() => items.map(() => false));
  const [cacheBuster] = useState(Date.now());

  const handleLoad = idx => {
    setLoaded(prev => {
      const copy = [...prev];
      copy[idx] = true;
      return copy;
    });
  };

  if (!items || items.length === 0) {
    return (
      <Box sx={sxStyle.skeletonImg}>
        <Skeleton
          variant="rectangular"
          sx={{ width: '100%', height: '100%', borderRadius: 2 }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...sxStyle.wrapper,
        '& .swiper-button-prev, & .swiper-button-next': {
          ...sxStyle.wrapper['& .swiper-button-prev, & .swiper-button-next'],
          '@media (min-width:600px)': {
            ...sxStyle.wrapper['& .swiper-button-prev, & .swiper-button-next'][
              '@media (min-width:600px)'
            ],
            display: showArrows ? 'flex !important' : 'none !important',
          },
        },
      }}
    >
      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        loop={multiple}
        autoplay={
          multiple && autoplay
            ? { delay: 3000, disableOnInteraction: false }
            : false
        }
        navigation={{ enabled: showArrows }}
        watchOverflow={false}
        style={{ width: '100%' }}
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide key={item.id || index}>
              <Box sx={{ position: 'relative' }}>
                {/* Skeleton mientras no cargó */}
                {!loaded[index] && (
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      ...sxStyle.img,
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: 2,
                    }}
                  />
                )}

                {/* Imagen real */}
                {item.link ? (
                  <Box
                    component="a"
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'block' }}
                  >
                    <Box
                      component="img"
                      src={`${item.image_slider}?cb=${cacheBuster}`}
                      onLoad={() => handleLoad(index)}
                      sx={{
                        ...sxStyle.img,
                        opacity: loaded[index] ? 1 : 0,
                        transition: 'opacity 0.4s ease',
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    component="img"
                    src={`${item.image_slider}?cb=${cacheBuster}`}
                    onLoad={() => handleLoad(index)}
                    sx={{
                      ...sxStyle.img,
                      opacity: loaded[index] ? 1 : 0,
                      transition: 'opacity 0.4s ease',
                    }}
                  />
                )}
              </Box>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Box>
  );
};

export default SliderBlock;
